@if (!loading) {
  <div class="content" cdkScrollable>
    <div class="header">
      <nav mat-tab-nav-bar mat-stretch-tabs="false" mat-align-tabs="center" [tabPanel]="tabPanel">
        @for (tabOption of tabBarOptions; track tabOption) {
          <a
            mat-tab-link
            (click)="optionSelected = tabOption.option"
            [active]="optionSelected === tabOption.option">
            {{ tabOption.text | locale }}
          </a>
        }
        <div class="bottom-bar"></div>
      </nav>
      <app-call-information [call]="call" [medicalHistory]="medicalHistory"/>
    </div>
    <!--
    mat-tab-nav-bar needs this to work but we don't use it.
    we're using mat-tab-nav-bar instead of mat-tab-group for styling purposes.
    -->
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
    <div [hidden]="optionSelected !== VisualizationOptions.CALL_FORM" class="confetti">
      @if (!diagnosisComplete) {
        <app-default-template label="consultation_details" [template]="diagnosis">
          <ng-template #diagnosis>
            <app-diagnosis
              [call]="call"
              [medicalHistory]="medicalHistory"
              [canPrescribeMedication]="capabilities.canPrescribeMedication"
              (diagnosisDuplicatedEvent)="getCall(null, $event)">
            </app-diagnosis>
          </ng-template>
        </app-default-template>
      }
      @if (diagnosisComplete) {
        <mat-tab-group class="tab-group-info" fitInkBarToContent [(selectedIndex)]="tabGroupInfoIndex">
          @if (call.provider.supportsPrescription && capabilities.canPrescribeMedication) {
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon svgIcon="pill"></mat-icon>
                @if (!mobileQuery.matches) {
                  <span>{{ "medicines_prescription" | locale }}</span>
                }
              </ng-template>
              <app-default-template label="medicines_prescription_details" [template]="prescription">
                <ng-template #prescription>
                  <app-prescription [call]="call" (nextStepEvent)="nextStep()"></app-prescription>
                </ng-template>
              </app-default-template>
            </mat-tab>
          }
          @if (call.provider.supportsMedicalOrder && (capabilities.canCreateMedicalOrderInstructions || capabilities.canCreateMedicalOrdersWithPractices || capabilities.canCreateFreeTextMedicalOrders)) {
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon svgIcon="exams"></mat-icon>
                @if (!mobileQuery.matches) {
                  <span>{{ "medical_orders" | locale }}</span>
                }
              </ng-template>
              <app-default-template label="medical_order_details" [template]="medicalOrder">
                <ng-template #medicalOrder>
                  <app-medical-order [call]="call" (nextStepEvent)="nextStep()"></app-medical-order>
                </ng-template>
              </app-default-template>
            </mat-tab>
          }
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon svgIcon="phone"></mat-icon>
              @if (!mobileQuery.matches) {
                <span>{{ "call_details" | locale }}</span>
              }
            </ng-template>
            <app-default-template label="call_details" [template]="rate">
              <ng-template #rate>
                <app-rate [call]="call"></app-rate>
              </ng-template>
            </app-default-template>
          </mat-tab>
        </mat-tab-group>
      }
    </div>
    <div [hidden]="optionSelected !== VisualizationOptions.MEDICAL_RECORDS" class="confetti">
      <app-default-template label="medical_record" [template]="hc">
        <ng-template #hc>
          <app-medical-records [call]="call" [patientCalls]="patientCalls"></app-medical-records>
        </ng-template>
      </app-default-template>
    </div>
    <div [hidden]="optionSelected !== VisualizationOptions.MEDICAL_EXAMS" class="confetti">
      <app-default-template label="tab_header_medical_exams" [template]="exams">
        <ng-template #exams>
          <app-medical-exams [call]="call" [filesByDates]="filesByDates"></app-medical-exams>
        </ng-template>
      </app-default-template>
    </div>
  </div>
}
